import styled from 'styled-components';

import { media } from 'helpers/breakpoints';

const Container = styled.div`
  display: grid;
  row-gap: ${({ theme }) => theme.spacing.S12};
  column-gap: 0;
  grid-template-columns: 1fr;

  ${media.large} {
    row-gap: 0;
    column-gap: ${({ theme }) => theme.spacing.M16};
    grid-template-columns: 1fr 200px;
  }
`;

export { Container };
